"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = lastTypingAt;

var _simpleUpdateIn = _interopRequireDefault(require("simple-update-in"));

var _incomingActivity = require("../actions/incomingActivity");

/*eslint no-case-declarations: "off"*/

/*eslint no-unused-vars: "off"*/
var DEFAULT_STATE = {};

function lastTypingAt() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      payload = _ref.payload,
      type = _ref.type;

  if (type === _incomingActivity.INCOMING_ACTIVITY) {
    var _payload$activity = payload.activity,
        _payload$activity$fro = _payload$activity.from,
        id = _payload$activity$fro.id,
        role = _payload$activity$fro.role,
        activityType = _payload$activity.type;

    if (role !== 'user') {
      if (activityType === 'typing') {
        state = (0, _simpleUpdateIn["default"])(state, [id], function () {
          return Date.now();
        });
      } else if (activityType === 'message') {
        state = (0, _simpleUpdateIn["default"])(state, [id]);
      }
    }
  }

  return state;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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